"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = lastTypingAt;

var _simpleUpdateIn = _interopRequireDefault(require("simple-update-in"));

var _incomingActivity = require("../actions/incomingActivity");

/*eslint no-case-declarations: "off"*/

/*eslint no-unused-vars: "off"*/
var DEFAULT_STATE = {};

function lastTypingAt() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      payload = _ref.payload,
      type = _ref.type;

  if (type === _incomingActivity.INCOMING_ACTIVITY) {
    var _payload$activity = payload.activity,
        _payload$activity$fro = _payload$activity.from,
        id = _payload$activity$fro.id,
        role = _payload$activity$fro.role,
        activityType = _payload$activity.type;

    if (role !== 'user') {
      if (activityType === 'typing') {
        state = (0, _simpleUpdateIn["default"])(state, [id], function () {
          return Date.now();
        });
      } else if (activityType === 'message') {
        state = (0, _simpleUpdateIn["default"])(state, [id]);
      }
    }
  }

  return state;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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